module.exports = __webpack_public_path__ + "static/img/h5-custom.599747e4.jpg";